import { createAction } from '@reduxjs/toolkit';

export const setCurrentStep = createAction('StepSmartPhone/currentStep/set');
export const clearPhone = createAction('StepSmartPhone/phone/clear');
export const setPhone = createAction('StepSmartPhone/phone/set');
